export function readFromLocalStorage(key: string) {
  return localStorage.getItem(key);
}

export function writeToLocalStorage(key: string, value: string) {
  localStorage.setItem(key, value);
}
